var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeftDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.20035 12C7.20035 11.3 7.47035 10.6 8.00035 10.07L14.5204 3.55002C14.8104 3.26002 15.2904 3.26002 15.5804 3.55002C15.8704 3.84002 15.8704 4.32002 15.5804 4.61002L9.06035 11.13C8.58035 11.61 8.58035 12.39 9.06035 12.87L15.5804 19.39C15.8704 19.68 15.8704 20.16 15.5804 20.45C15.2904 20.74 14.8104 20.74 14.5204 20.45L8.00035 13.93C7.47035 13.4 7.20035 12.7 7.20035 12Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftDark);
export default __webpack_public_path__ + "static/media/arrow-left-dark.b520a222e9c6c490806ada65e6fdae10.svg";
export { ForwardRef as ReactComponent };